module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/253fd3f7e0f97cef20eb5a68f66d5b5c.png";